export default {
  menu: {
    dashboard: "Dashboard",
    sales: "Penjualan",
    orders: "Pesanan",
    shipments: "Pengiriman",
    invoices: "Faktur",
    transactions: "Transaksi",

    catalog: "Katalog",
    products: "Produk",
    categories: "Kategori",
    woods: "Kayu",
    warehouses: "Gudang",

    settings: "Pengaturan",
    general: "Umum",
    users: "Pengguna",
  },

  common: {
    add: "Tambah",
    cancel: "Batal",
    save: "Simpan",
    delete: "Hapus",
    title: "Judul",
    description: "Deskripsi",
    faq: "FAQ",
    contact: "Hubungi Kami",
    tos: "Syarat Layanan",
    policy: "Kebijakan Privasi",
  },
  login: {
    title: "Masuk",
    email: "Email",
    userOrEmail: "Nama Pengguna atau Email",
    password: "Kata Sandi",
    button: "Masuk",
    orsign: "Atau masuk dengan",
    forgot: "Lupa kata sandi?",
    forgotPassword: "Lupa Kata Sandi?",
    noaccount: "Belum punya akun?",
    create: "Buat di sini",
    error: "Kombinasi email / kata sandi tidak valid",
  },
  register: {
    title: "Buat Akun",
    username: "Nama Pengguna",
    email: "Email",
    password: "Kata Sandi",
    button: "Buat Akun",
    orsign: "Atau daftar dengan",
    agree: "Dengan mendaftar, Anda menyetujui",
    account: "Sudah punya akun?",
    signin: "Masuk",
  },
  forgotPassword: {
    title: "Lupa Kata Sandi",
    subtitle: "Masukkan alamat email Anda dan kami akan mengirimkan OTP untuk mereset kata sandi",
    email: "Alamat Email",
    button: "Kirim OTP Reset",
    backToLogin: "Kembali ke Login",
  },
  resetPassword: {
    title: "Reset Kata Sandi",
    subtitle: "Masukkan OTP 6 digit yang dikirim ke email Anda dan buat kata sandi baru",
    email: "Alamat Email",
    otpLabel: "Kode OTP 6 Digit",
    newPassword: "Kata Sandi Baru",
    confirmPassword: "Konfirmasi Kata Sandi Baru",
    button: "Reset Kata Sandi",
    backToLogin: "Kembali ke Login",
  },
  myAccount: {
    title: "Akun Saya",
    tabs: {
      profile: "Profil",
      security: "Keamanan",
    },
    profile: {
      title: "Informasi Profil",
      displayName: "Nama Tampilan",
      save: "Simpan Perubahan",
    },
    changeEmail: {
      title: "Ubah Email",
      currentEmail: "Email Saat Ini",
      newEmail: "Email Baru",
      currentPassword: "Kata Sandi Saat Ini",
      save: "Ubah Email",
    },
    changePassword: {
      title: "Ubah Kata Sandi",
      newPassword: "Kata Sandi Baru",
      confirmPassword: "Konfirmasi Kata Sandi Baru",
      save: "Ubah Kata Sandi",
    },
    passwordConfirm: {
      title: "Konfirmasi Kata Sandi",
      warningTitle: "Verifikasi Keamanan Diperlukan",
      warningText: "Untuk melindungi akun Anda, silakan masukkan kata sandi saat ini untuk mengonfirmasi perubahan email ini.",
      confirmationText: "Apakah Anda yakin ingin mengubah email dari:",
      emailLabel: "Email Saat Ini",
      newEmailLabel: "Email Baru",
      passwordLabel: "Kata Sandi Saat Ini",
      cancel: "Batal",
      confirm: "Ubah Email",
    },
    currentPasswordConfirm: {
      title: "Konfirmasi Kata Sandi Saat Ini",
      warningTitle: "Verifikasi Keamanan Diperlukan",
      warningText: "Untuk melindungi akun Anda, silakan masukkan kata sandi saat ini untuk mengonfirmasi perubahan kata sandi ini.",
      confirmationText: "Anda akan mengubah kata sandi",
      passwordLabel: "Kata Sandi Saat Ini",
      cancel: "Batal",
      confirm: "Ubah Kata Sandi",
    },
    security: {
      title: "Pengaturan Keamanan",
      comingSoon: "Pengaturan keamanan akan segera tersedia.",
      activeSessions: "Sesi Aktif",
      logoutAll: "Keluar Semua",
      currentSession: "Saat Ini",
      lastActivity: "Aktivitas terakhir",
      expires: "Berakhir",
      revoke: "Cabut",
      refresh: "Perbarui",
      noSessions: "Tidak ada sesi aktif ditemukan.",
      logoutAllConfirm: {
        title: "Keluar Dari Semua Sesi",
        warningTitle: "Ini akan mengakhiri semua sesi Anda",
        warningText: "Anda akan keluar dari semua perangkat dan perlu masuk lagi.",
        description: "Ini akan mencabut {count} sesi lain dan mengeluarkan Anda dari semua perangkat.",
        cancel: "Batal",
        confirm: "Keluar Semua",
      },
    },
  },
  profile: {
    title: "Edit Profil",
    email: "Alamat Email",
    displayName: "Nama Tampilan",
    save: "Simpan Perubahan",
    reset: "Reset",
    editProfile: "Edit Profil",
  },
  dashboard: {
    activity: "Aktivitas",
    weeklySales: "Penjualan Mingguan",
    sales: "Penjualan",
    recentOrders: "Pesanan Terbaru",
    sources: "Sumber Lalu Lintas",
    lastweek: "dibanding minggu lalu",
    orders: "Pesanan",
    customers: "Pelanggan",
    tickets: "Tiket Dukungan",
    viewReport: "Lihat Laporan",
  },
  10: "10",
  25: "25",
  50: "50",
  100: "100",
  // Terjemahan komponen Vuetify
  $vuetify: {
    input: {
      clear: "Hapus"
    },
    badge: "Lencana",
    close: "Tutup",
    dataIterator: {
      noResultsText: "Tidak ada data yang cocok",
      loadingText: "Memuat item...",
    },
    dataTable: {
      itemsPerPageText: "Baris per halaman:",
      ariaLabel: {
        sortDescending: "Diurutkan menurun.",
        sortAscending: "Diurutkan menaik.",
        sortNone: "Tidak diurutkan.",
        activateNone: "Aktifkan untuk menghapus pengurutan.",
        activateDescending: "Aktifkan untuk mengurutkan menurun.",
        activateAscending: "Aktifkan untuk mengurutkan menaik.",
      },
      sortBy: "Urutkan berdasarkan",
    },
    dataFooter: {
      itemsPerPageText: "Item per halaman:",
      itemsPerPageAll: "Semua",
      nextPage: "Halaman berikutnya",
      prevPage: "Halaman sebelumnya",
      firstPage: "Halaman pertama",
      lastPage: "Halaman terakhir",
      pageText: "{0}-{1} dari {2}",
    },
    datePicker: {
      itemsSelected: "{0} dipilih",
      nextMonthAriaLabel: "Bulan berikutnya",
      nextYearAriaLabel: "Tahun berikutnya",
      prevMonthAriaLabel: "Bulan sebelumnya",
      prevYearAriaLabel: "Tahun sebelumnya",
    },
    noDataText: "Tidak ada data",
    carousel: {
      prev: "Visual sebelumnya",
      next: "Visual berikutnya",
      ariaLabel: {
        delimiter: "Slide {0} dari {1}",
      },
    },
    calendar: {
      moreEvents: "{0} lagi",
    },
    fileInput: {
      counter: "{0} berkas",
      counterSize: "{0} berkas ({1} total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Navigasi Paginasi",
        next: "Halaman berikutnya",
        previous: "Halaman sebelumnya",
        page: "Ke Halaman {0}",
        currentPage: "Halaman Saat Ini, Halaman {0}",
      },
    },
  },
};
